export default __webpack_public_path__ + "static/diners-a0f092619e1a1d311df8d090eaf7b1a8.svg";